import { __module as objectWithoutProperties } from '../../../../_virtual/objectWithoutProperties.js';
import './objectWithoutPropertiesLoose.js';
import { exports as objectWithoutPropertiesLooseExports } from '../../../../_virtual/objectWithoutPropertiesLoose.js';

(function (module) {
	var objectWithoutPropertiesLoose = objectWithoutPropertiesLooseExports;
	function _objectWithoutProperties(e, t) {
	  if (null == e) return {};
	  var o,
	    r,
	    i = objectWithoutPropertiesLoose(e, t);
	  if (Object.getOwnPropertySymbols) {
	    var s = Object.getOwnPropertySymbols(e);
	    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
	  }
	  return i;
	}
	module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (objectWithoutProperties));
//# sourceMappingURL=objectWithoutProperties.js.map
